import * as React from 'react';

import { Drawer } from '@/components/ui';

import { NaplanDrawerContent } from './naplan-drawer-content';

interface NaplanDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NaplanDrawer: React.FC<NaplanDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      contentClassName="bg-magical-moonlight-white"
      childClass="!max-w-full"
      topOffset="top-[25%]"
      closeButtonPosition={{ top: 'top-[20%]', right: 'right-6' }}
      innerContentClassName="p-2 md:p-3"
      role="dialog"
      aria-modal="true"
    >
      <NaplanDrawerContent onClose={onClose} />
    </Drawer>
  );
};
